// Translator notes: Finnish → HV rules from Axel's Finnish corrections of 2026-10-07 (engine/src/finnish-constructions.ts
// fi-valency-lemma, engine/src/finnish-parse.ts fi-wear-on). Each id is an engine note (`notes.add(text, id, args)`);
// `args` names its arguments in the order the strings take them. Collected by translator/notes.ts (import.meta.glob).
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  fiValencyLemma: {
    args: ['word', 'hv'],
    fi: (a: string[]) => `”${a[0]}” käännettiin verbillä ${a[1]}, koska objektina on asia ja sanakirjan mukaan juuri ${a[1]} ottaa sellaisen objektin.`,
    en: (a: string[]) => `“${a[0]}” was translated with ${a[1]}: its object is a thing, and the dictionary gives ${a[1]} for that object.`,
  },
  fiWearOn: {
    args: ['hv'],
    fi: (a: string[]) => `”Jollakulla on jotakin päällään” tarkoittaa, että hänellä on se yllään, joten se käännettiin verbillä ${a[0]} (pitää yllään).`,
    en: (a: string[]) => `“Jollakulla on jotakin päällään” (someone has something on) means wearing it, so it was translated with ${a[0]} (to wear).`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
